import React, { Component } from 'react';

export default class CircleResult extends Component {
  state = {
    percent: 8
  }

  componentDidMount() {
    const percent = Math.floor(Math.random() * (90 - 80 + 1) + 80);
  let styleSheet = document.styleSheets[0];

  let keyframes =
    `@-webkit-keyframes donutrandom {
      0% {
        stroke-dasharray: 0, 100;
    }
      100% {
          stroke-dasharray: ${percent}, ${100 - percent};
      }
    }`;
 
    styleSheet.insertRule(keyframes, styleSheet.cssRules.length);

    this.setState({
      percent,
    })
  }

  render() {
    const { percent } = this.state;



 

    return (
      <div className="svg-item">
        <svg width="100%" height="100%" viewBox="0 0 40 40" className="donut">
          <circle className="donut-hole" cx={20} cy={20} r="15.91549430918954" fill="#fff" />
          <circle
            className="donut-ring"
            cx={20}
            cy={20}
            r="15.91549430918954"
            fill="transparent"
            strokeWidth="3.5"
          />
          <circle
            className="donut-segment donut-segment-2"
            id="doddd"
            cx={20}
            cy={20}
            r="15.91549430918954"
            fill="transparent"
            strokeWidth="3.5"
            strokeDasharray={`${percent} ${100 - percent}`}
            strokeDashoffset={25}
            style={{
              // animation: inEffect,
              animationDuration: '3s',
              animationName: "donutrandom"
            }}
          />
          
          <g className="donut-text donut-text-1">
          <text y="45%" transform="translate(0, 2)">
              <tspan x="50%" textAnchor="middle" className="donut-percent text-special-percent">
              {percent}%

              </tspan>
            </text>
          <text y="60%" transform="translate(0, 2)">
              <tspan x="50%" textAnchor="middle" className="donut-data text-special">
                Tỷ lệ đậu

              </tspan>
            </text>
            
           
          </g>
        </svg>
      </div>
    );
  }
}
